import React from 'react';
import './StatBlock.css';

const StatBlock = ({ icon, value, label }) => (
  <div className="stat-block">
    <div className="stat-block__top">
      <div className="stat-block__icon-circle">
        <span className="material-icons stat-block__icon">{icon}</span>
      </div>
      <span className="stat-block__value">{value ?? '—'}</span>
    </div>
    <p className="stat-block__label">{label}</p>
  </div>
);

export default StatBlock;
